import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{! DO NOT EDIT THIS FILE!!! }}
{{! Update it by running `rake javascript:update_constants` }}

<button
  type="button"
  data-section="smileys_&_emotion"
  {{on "click" (fn this.onCategorySelection "smileys_&_emotion")}}
  class="btn btn-default category-button emoji"
>
  {{replace-emoji ":grinning:"}}
</button>
<button
  type="button"
  data-section="people_&_body"
  {{on "click" (fn this.onCategorySelection "people_&_body")}}
  class="btn btn-default category-button emoji"
>
  {{replace-emoji ":wave:"}}
</button>
<button
  type="button"
  data-section="animals_&_nature"
  {{on "click" (fn this.onCategorySelection "animals_&_nature")}}
  class="btn btn-default category-button emoji"
>
  {{replace-emoji ":evergreen_tree:"}}
</button>
<button
  type="button"
  data-section="food_&_drink"
  {{on "click" (fn this.onCategorySelection "food_&_drink")}}
  class="btn btn-default category-button emoji"
>
  {{replace-emoji ":hamburger:"}}
</button>
<button
  type="button"
  data-section="travel_&_places"
  {{on "click" (fn this.onCategorySelection "travel_&_places")}}
  class="btn btn-default category-button emoji"
>
  {{replace-emoji ":airplane:"}}
</button>
<button
  type="button"
  data-section="activities"
  {{on "click" (fn this.onCategorySelection "activities")}}
  class="btn btn-default category-button emoji"
>
  {{replace-emoji ":soccer:"}}
</button>
<button
  type="button"
  data-section="objects"
  {{on "click" (fn this.onCategorySelection "objects")}}
  class="btn btn-default category-button emoji"
>
  {{replace-emoji ":eyeglasses:"}}
</button>
<button
  type="button"
  data-section="symbols"
  {{on "click" (fn this.onCategorySelection "symbols")}}
  class="btn btn-default category-button emoji"
>
  {{replace-emoji ":white_check_mark:"}}
</button>
<button
  type="button"
  data-section="flags"
  {{on "click" (fn this.onCategorySelection "flags")}}
  class="btn btn-default category-button emoji"
>
  {{replace-emoji ":checkered_flag:"}}
</button>
*/
{
  "id": "iC9BVZ2M",
  "block": "[[[1,\"\\n\"],[11,\"button\"],[24,\"data-section\",\"smileys_&_emotion\"],[24,0,\"btn btn-default category-button emoji\"],[24,4,\"button\"],[4,[38,0],[\"click\",[28,[37,1],[[30,0,[\"onCategorySelection\"]],\"smileys_&_emotion\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,2],[\":grinning:\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[11,\"button\"],[24,\"data-section\",\"people_&_body\"],[24,0,\"btn btn-default category-button emoji\"],[24,4,\"button\"],[4,[38,0],[\"click\",[28,[37,1],[[30,0,[\"onCategorySelection\"]],\"people_&_body\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,2],[\":wave:\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[11,\"button\"],[24,\"data-section\",\"animals_&_nature\"],[24,0,\"btn btn-default category-button emoji\"],[24,4,\"button\"],[4,[38,0],[\"click\",[28,[37,1],[[30,0,[\"onCategorySelection\"]],\"animals_&_nature\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,2],[\":evergreen_tree:\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[11,\"button\"],[24,\"data-section\",\"food_&_drink\"],[24,0,\"btn btn-default category-button emoji\"],[24,4,\"button\"],[4,[38,0],[\"click\",[28,[37,1],[[30,0,[\"onCategorySelection\"]],\"food_&_drink\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,2],[\":hamburger:\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[11,\"button\"],[24,\"data-section\",\"travel_&_places\"],[24,0,\"btn btn-default category-button emoji\"],[24,4,\"button\"],[4,[38,0],[\"click\",[28,[37,1],[[30,0,[\"onCategorySelection\"]],\"travel_&_places\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,2],[\":airplane:\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[11,\"button\"],[24,\"data-section\",\"activities\"],[24,0,\"btn btn-default category-button emoji\"],[24,4,\"button\"],[4,[38,0],[\"click\",[28,[37,1],[[30,0,[\"onCategorySelection\"]],\"activities\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,2],[\":soccer:\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[11,\"button\"],[24,\"data-section\",\"objects\"],[24,0,\"btn btn-default category-button emoji\"],[24,4,\"button\"],[4,[38,0],[\"click\",[28,[37,1],[[30,0,[\"onCategorySelection\"]],\"objects\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,2],[\":eyeglasses:\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[11,\"button\"],[24,\"data-section\",\"symbols\"],[24,0,\"btn btn-default category-button emoji\"],[24,4,\"button\"],[4,[38,0],[\"click\",[28,[37,1],[[30,0,[\"onCategorySelection\"]],\"symbols\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,2],[\":white_check_mark:\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[11,\"button\"],[24,\"data-section\",\"flags\"],[24,0,\"btn btn-default category-button emoji\"],[24,4,\"button\"],[4,[38,0],[\"click\",[28,[37,1],[[30,0,[\"onCategorySelection\"]],\"flags\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,2],[\":checkered_flag:\"],null]],[1,\"\\n\"],[13]],[],false,[\"on\",\"fn\",\"replace-emoji\"]]",
  "moduleName": "discourse/components/emoji-group-buttons.hbs",
  "isStrictMode": false
});